import { createContext, useState } from 'react'

import { defaultTheme } from './default-theme'

export const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(defaultTheme)

  const value = {
    theme: currentTheme,
    setTheme: setCurrentTheme,
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}
